export default [
    'Puente Alto',
    'Maipú',
    'Santiago',
    'La Florida',
    'Antofagasta',
    'Viña del Mar',
    'Valparaíso',
    'Las Condes',
    'San Bernardo',
    'Peñalolén',
    'Temuco',
    'Rancagua',
    'Concepción',
    'Quilicura',
    'Ñuñoa',
    'Talca',
    'Pudahuel',
    'Coquimbo',
    'Arica',
    'La Serena',
    'Iquique',
    'La Pintana',
    'Puerto Montt',
    'Chillán',
    'El Bosque',
    'Calama',
    'Recoleta',
    'Copiapó',
    'Valdivia',
    'Quilpué',
    'Talcahuano',
    'Osorno',
    'Renca',
    'Los Ángeles',
    'Providencia',
    'Estación Central',
    'Cerro Navia',
    'San Pedro de la Paz',
    'Conchalí',
    'Curicó',
    'Villa Alemana',
    'Punta Arenas',
    'La Granja',
    'Macul',
    'Coronel',
    'Quinta Normal',
    'San Miguel',
    'Alto Hospicio',
    'Lo Barnechea',
    'Pedro Aguirre Cerda',
    'Independencia',
    'Lo Espejo',
    'Huechuraba',
    'Lo Prado',
    'San Joaquín',
    'La Reina',
    'Hualpén',
    'La Cisterna',
    'Colina',
    'San Antonio',
    'Chiguayante',
    'Vitacura',
    'Peñaflor',
    'San Ramón',
    'Cerrillos',
    'Ovalle',
    'Linares',
    'Quillota',
    'Melipilla',
    'Buin',
    'San Felipe',
    'Los Andes',
    'San Fernando',
    'Talagante',
    'Padre Hurtado',
    'Coyhaique',
    'Machalí',
    'Angol',
    'Calera',
    'Penco',
    'Vallenar',
    'Lota',
    'Tomé',
    'Puerto Montt',
    'Padre Las Casas',
    'Concón',
    'Valparaíso',
    'Limache',
    'Rengo',
    'Lampa',
    'Molina',
    'Constitución',
    'Castro',
    'San Carlos',
    'Cauquenes',
    'Villarrica',
    'Paine',
    'Parral',
    'Maule',
    'Curanilahue',
    'El Monte',
    'San Javier',
    'Graneros',
    'Ancud',
    'Chillán Viejo',
    'La Unión',
    'Quintero',
    'Puerto Varas',
    'Victoria',
    'Tocopilla',
    'Lautaro',
    'Mulchén',
    'Temuco',
    'Nacimiento',
    'Santa Cruz',
    'Lebu',
    'San Vicente',
    'Cartagena',
    'Illapel',
    'San Clemente',
    'Hualqui',
    'La Cruz',
    'Cañete',
    'La Ligua',
    'Natales',
    'Nueva Imperial',
    'Curacaví',
    'Casablanca',
    'Llaillay',
    'Arauco',
    'Quellón',
    'Pucón',
    'Aysén',
    'Lampa',
    'Río Bueno',
    'Chimbarongo',
    'Lampa',
    'Pitrufquén',
    'Collipulli',
    'Laja',
    'Calbuco',
    'Vicuña',
    'Caldera',
    'Loncoche',
    'Los Álamos',
    'Cabrero',
    'El Quisco',
    'Traiguén',
    'Isla de Maipo',
    'Los Vilos',
    'Salamanca',
    'Llanquihue',
    'Frutillar',
    'Mejillones',
    'Pichilemu',
    'Mostazal',
    'Purranque',
    'Olmué',
    'Pudahuel',
    'Isla de Maipo',
    'Carahue',
    'Paillaco',
    'Panguipulli',
    'Chañaral',
    'Bulnes',
    'Colina',
    'Taltal',
    'Cabildo',
    'Yungay',
    'Requínoa',
    'Coelemu',
    'San Esteban',
    'Quillón',
    'Andacollo',
    'Tierra Amarilla',
    'Nogales',
    'Mariquina',
    'Yumbel',
    'Los Lagos',
    'Calle Larga',
    'Santa Juana',
    'Teno',
    'Quirihue',
    'Hijuelas',
    'Pozo Almonte',
    'Coihueco',
    'Algarrobo',
    'Doñihue',
    'Nogales',
    'Pirque',
    'Nancagua',
    'Gorbea',
    'Peumo',
    'Lanco',
    'Puchuncaví',
    'Villa Alegre',
    'Rinconada',
    'Santa Bárbara',
    'Los Muermos',
    'Calera de Tango',
    'Tucapel',
    'Catemu',
    'Las Cabras',
    'Colina',
    'Santa María',
    'Purén',
    'Doñihue',
    'Fresia',
    'Diego de Almagro',
    'Quinta de Tilcoco',
    'Cunco',
    'Isla de Pascua',
    'Dalcahue',
    'Longaví',
    'Futrono',
    'Huasco',
    'Maule',
    'Buin',
    'Mostazal',
    'El Tabo',
    'Río Negro',
    'Colbún',
    'Putaendo',
    'Codegua',
    'Cabrero',
    'Monte Patria',
    'Renaico',
    'Romeral',
    'Vilcún',
    'San José de Maipo',
    'Monte Patria',
    'Santo Domingo',
    'Chépica',
    'Paine',
    'Diego de Almagro',
    'Porvenir',
    'Combarbalá',
    'Hualañé',
    'Punitaqui',
    'Vilcún',
    'Chonchi',
    'Pichidegua',
    'Coquimbo',
    'Tiltil',
    'Rauco',
    'Retiro',
    'El Tabo',
    'Coltauco',
    'Freire',
    'Olivar',
    'San Pedro de Atacama',
    'Melipilla',
    'Peralillo',
    'Puchuncaví',
    'Arauco',
    'Chile Chico',
    'Cochrane',
    'Cabo de Hornos',
    'Putre',
    'Chaitén',
]
